import axiosInstance from "./axios";

export const getTokenByShortCode = async (code) => {
  const res = await axiosInstance.get(
    `/api/v1/external/referrals/claim/by-code/${encodeURIComponent(code)}`,
  );
  return res.data; // { token: "..." }
};

export const getClaimSummary = async (token) => {
  const res = await axiosInstance.get("/api/v1/external/referrals/claim", {
    params: { token },
  });
  return res.data;
};

export const verifyClaimIdentity = async ({ token, npi, lastName }) => {
  const res = await axiosInstance.post(
    "/api/v1/external/referrals/claim/verify",
    {
      token,
      npi,
      lastName,
    },
  );
  return res.data;
};

export const acceptReferral = async ({ token, npi, lastName }) => {
  await axiosInstance.post("/api/v1/external/referrals/claim/accept", {
    token,
    npi,
    lastName,
  });
};

export const declineReferral = async ({ token, npi, lastName, reason }) => {
  await axiosInstance.post("/api/v1/external/referrals/claim/decline", {
    token,
    npi,
    lastName,
    reason,
  });
};
